// extracted by mini-css-extract-plugin
module.exports = {"title":"Email_title__2yXF4"};